import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { Route, Switch } from 'react-router';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PrivateRoute from './components/PrivateRoute';
import configureStore from './store/configureStore';
import App from './App';
import Login from './containers/Login/Login';
import ContactAdmin from './containers/ContactAdmin/ContactAdmin';
import Register from './containers/Register/Register';
import registerServiceWorker from './registerServiceWorker';
import ConnectedIntlProvider from "./components/ConnectedIntlProvider";

// Setting up stripe account with public key
const stripePromise = loadStripe("pk_test_uzsIHqNQKl5QTMC5yT06qYPU00ZA8o6phW");

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

ReactDOM.render(
    <Elements stripe={stripePromise}>
        <Provider store={store}>
            <ConnectedIntlProvider>
                <ConnectedRouter history={history}>
                    <Switch>
                        <Route exact={true} path="/Login" component={Login} />
                        <Route path="/Register" component={Register} />
                        <Route path="/ContactAdmin" component={ContactAdmin} />
                        <PrivateRoute exact={true} path="/" component={App} />
                        <PrivateRoute component={App} />
                    </Switch>
                </ConnectedRouter>
            </ConnectedIntlProvider>
        </Provider>
    </Elements>,
    rootElement);

registerServiceWorker();
